import { ILog } from './log.interface';

export class LogSimulator implements ILog {
  info(message: any) { }
  warning(message: any) { }
  error(message: any) { }
  debug(message: any) { }
}
